declare global {
  interface Window {
    dataLayer: Array<Record<string, unknown>>
  }
}

type EventName = 'ViewOnMobile' | 'ViewOnDesktop' | 'PlaySound' | 'ClickHotspot' | 'ViewInAR';

export type TrackingEvent = {
  event: EventName,
  value?: string,
  animal?: string,
  lang?: string,
  sound?: string
}

export const track = (event: TrackingEvent): void => {
  if (window.dataLayer) {
    window.dataLayer.push(event);
  }
};
